export default "__VITE_ASSET__D6Kv7PHw__"